'use client';
import Logout from '@/app/_components/ui/icons/Logout.svg';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { signOut, useSession } from 'next-auth/react';
import Home2 from '@/app/_components/ui/icons/Home2.svg';
import Bag from '@/app/_components/ui/icons/Bag.svg';
import Coupon from '@/app/_components/ui/icons/Coupon.svg';
import Heart from '@/app/_components/ui/icons/Heart.svg';
import Location from '@/app/_components/ui/icons/Location.svg';
import Comments2 from '@/app/_components/ui/icons/Comments2.svg';
import Notification from '@/app/_components/ui/icons/Notification.svg';
import Clock from '@/app/_components/ui/icons/Clock.svg';
import Profile from '@/app/_components/ui/icons/Profile.svg';
import OpenBook from '@/app/_components/ui/icons/OpenBook.svg';
import { useIsMobile } from '@/app/_hooks/useIsMobile';

const iconComponents = {
  Home2,
  Bag,
  Coupon,
  Location,
  Heart,
  Comments2,
  Notification,
  Clock,
  Profile,
  OpenBook,
};

export default function ProfileAside() {
  const router = useRouter();
  const { data: session, status } = useSession();
  const profileItems = [
    {
      name: 'پیشخوان',
      path: '/profile',
      icon: {
        name: 'Home2',
        type: 'fill',
      },
    },
    {
      name: 'سفارش ها',
      path: '/profile/orders',
      icon: {
        name: 'Bag',
        type: 'stroke',
      },
    },
    {
      name: 'کدهای تخفیف',
      path: '/profile/coupons',
      icon: {
        name: 'Coupon',
        type: 'strock',
      },
    },
    {
      name: 'آدرس ها',
      path: '/profile/addresses',
      icon: {
        name: 'Location',
        type: 'fill',
      },
    },
    {
      name: 'درخواست ها',
      path: '/profile/requests',
      icon: {
        name: 'OpenBook',
        type: 'fill',
      },
    },
    {
      name: 'علاقه مندی ها',
      path: '/profile/lists',
      icon: {
        name: 'Heart',
        type: 'fill',
      },
    },
    {
      name: 'دیدگاه ها',
      path: '/profile/comments',
      icon: {
        name: 'Comments2',
        type: 'stroke',
      },
    },
    {
      name: 'پیغام ها',
      path: '/profile/notification',
      icon: {
        name: 'Notification',
        type: 'stroke',
      },
    },
    {
      name: 'بازدیدهای اخیر',
      path: '/profile/user-history',
      icon: {
        name: 'Clock',
        type: 'stroke',
      },
    },
    {
      name: 'اطلاعات حساب کاربری',
      path: '/profile/personal-info',
      icon: {
        name: 'Profile',
        type: 'stroke',
      },
    },
  ];
  return (
    <>
      <div className="profile-side md:p-4 md:sticky top-0 ">
        <div className="profile-avatar flex items-center md:mb-8 md:p-4 pb-2">
          <Image
            src="/images/avatar.svg"
            width="50"
            height="50"
            alt="barghchi avatar"
          />
          {status === 'authenticated' ? (
            <div className="px-2">{session.user?.mobile}</div>
          ) : (
            <></>
          )}
        </div>
        <div className="profile-menu text-gray-700">
          {profileItems.map((item, index) => {
            const IconComponent = iconComponents[item.icon.name];
            return (
              <div
                className={`py-3 my-2 text-sm md:text-base md:px-4 border-b lg:border-none border-light-gray-300  ${
                  router.pathname == item.path
                    ? 'bg-light-blue-200 text-color-primary rounded-md'
                    : ''
                }`}
                key={index}
              >
                <Link href={item.path} className="flex">
                  <IconComponent
                    stroke={`${
                      router.pathname == item.path ? '#2A75BB' : '#292D32'
                    }`}
                  />
                  <span className="pr-4">{item.name}</span>
                </Link>
              </div>
            );
          })}
          <div
            onClick={() => signOut({ callbackUrl: '/' })}
            className="py-3 my-2 px-4 bg cursor-pointer"
          >
            <Link className="flex" href="#">
              <Logout />
              <span className="pr-4"> خروج </span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
